<template>
  <div :class="{ 'banner-container': showUserInfo, 'no-banner': !showUserInfo }">
    <div class="banner-section">
      <el-carousel
        :height="showUserInfo ? '436px' : '500px'"
        class="banner-carousel"
        :autoplay="true"
        :interval="5000"
        :loop="true"
        indicator-position="outside"
      >
        <el-carousel-item v-for="item in list" :key="item.content">
          <div
            :class="{ 'carousel-image-wrapper': true, 'cursor-pointer': checkBannerCanClick(item) }"
            @click="clickImg(item)"
          >
            <el-image class="carousel-image" :src="item.content" fit="cover"></el-image>
            <div class="carousel-overlay"></div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="user-card-section" v-if="showUserInfo">
      <div class="user-card">
        <template v-if="userInfo.userId">
          <div class="user-header">
            <div class="user-avatar">
              <img class="avatar-img" :src="userInfo.avatar || defaultAvatarIcon" alt="用户头像" />
            </div>
            <div class="user-details">
              <div class="user-name">{{ userInfo.username }}</div>
              <div class="user-account">{{ userInfo.account }}</div>
              <div class="user-company">{{ userInfo.companyName }}</div>
            </div>
          </div>

          <div class="user-actions">
            <button class="action-btn switch-btn" @click="changeAccountManage">
              <i class="fas fa-exchange-alt"></i>
              切换账户
            </button>
            <button class="action-btn logout-btn" @click="loginOut">
              <i class="fas fa-sign-out-alt"></i>
              退出登录
            </button>
          </div>

          <div class="stats-section">
            <div class="stats-title">订单状态</div>
            <div class="stats-grid">
              <div class="stat-item cursor-pointer" @click="toOrderList('1')">
                <div class="stat-number">{{ countObj.toConfirm || 0 }}</div>
                <div class="stat-label">待确认</div>
              </div>
              <div class="stat-item cursor-pointer" @click="toOrderList('9')">
                <div class="stat-number">{{ countObj.toPay || 0 }}</div>
                <div class="stat-label">待付款</div>
              </div>
              <div class="stat-item cursor-pointer" @click="toOrderList('2')">
                <div class="stat-number">{{ countObj.toDeliver || 0 }}</div>
                <div class="stat-label">待发货</div>
              </div>
              <div class="stat-item cursor-pointer" @click="toOrderList('3')">
                <div class="stat-number">{{ countObj.toReceive || 0 }}</div>
                <div class="stat-label">待收货</div>
              </div>
            </div>
          </div>

          <div class="benefits-section">
            <div class="benefits-title">我的权益</div>
            <div class="benefits-grid">
              <div
                class="benefit-item cursor-pointer"
                @click="$router.push({ path: '/new-products/system-center/my-wallet', query: { name: 'coupon' } })"
              >
                <div class="benefit-icon coupon-icon">
                  <i class="fas fa-ticket-alt"></i>
                </div>
                <div class="benefit-content">
                  <div class="benefit-number">{{ userInfo.coupon || 0 }}</div>
                  <div class="benefit-label">优惠券</div>
                </div>
              </div>
              <div
                class="benefit-item cursor-pointer"
                @click="$router.push({ path: '/new-products/system-center/my-wallet', query: { name: 'points' } })"
              >
                <div class="benefit-icon points-icon">
                  <i class="fas fa-star"></i>
                </div>
                <div class="benefit-content">
                  <div class="benefit-number">{{ userInfo.points || 0 }}</div>
                  <div class="benefit-label">积分</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="noLogo">
            <div class="no-logo-content">
              <div class="no-logo-avatar">
                <img class="avatar-img" :src="defaultAvatarIcon" alt="默认头像" />
              </div>
              <div class="no-logo-text">
                <div class="welcome-line1">HI 你好</div>
                <div class="welcome-line2">xxx欢迎您，请登录~</div>
                <div class="welcome-tip">登录后享受更多优惠</div>
              </div>
              <div class="no-logo-actions">
                <button class="action-btn register-btn" @click="handleRegister" v-if="showRegister">
                  <i class="fas fa-user-plus"></i>
                  注册
                </button>
                <button class="action-btn login-btn" @click="handleLogin">
                  <i class="fas fa-sign-in-alt"></i>
                  登录
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <AccountManage ref="accountManage" />
  </div>
</template>

<script>
import defaultAvatarIcon from "@/assets/img/newProducts/defaultAvatar.png";
import AccountManage from "@/components/AccountManage";
import { logout } from "@/api/base";
import { mapState } from "vuex";
import { getOrdersCounts } from "@/api/order/index.js";
import { getGoodsList } from "@/api/goods/index.js";

export default {
  components: {
    AccountManage
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    showUserInfo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("user", {
      userInfo: state => {
        return state.userInfo;
      }
    }),
    showRegister() {
      return this.$store.state.companyInfo.company.setting.allowExternalRegistration;
    }
  },
  watch: {
    list: {
      handler(newV) {
        if (newV && newV.length > 0) {
          this.$nextTick(() => {
            this.$bus.$emit("resetLeftNav");
          });
        }
      },
      immediate: true,
      deep: true
    },
    userInfo: {
      handler(newv) {},
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      defaultAvatarIcon,
      countObj: {}
    };
  },
  methods: {
    toOrderList(id) {
      this.$router.push({ path: "/new-products/system-center/order-list", query: { id } });
    },
    handleRegister() {
      // 注册逻辑
      // this.$router.push('/register');
      this.$router.push({ path: "/login", query: { method: "register" } });
    },

    handleLogin() {
      // 登录逻辑
      this.$router.push("/login");
    },
    //判断banner图是否可点击
    checkBannerCanClick(item) {
      if (item.checkedLink === 1) {
        if (!item.externalLink) {
          return false;
        }
        // 外部链接
        if (item.externalLink === "https://") {
          return false;
        }
        return true;
      } else {
        if (item.internalLink && item.internalLink.sub && item.internalLink.sub.name) {
          return true;
        }
      }
      return false;
    },
    async clickImg(item) {
      if (item.checkedLink === 1) {
        if (!item.externalLink) {
          return;
        }
        // 外部链接
        if (item.externalLink === "https://") {
          this.$message.error("错误连接");
          return;
        }
        window.open(item.externalLink);
      } else {
        if (item.internalLink && item.internalLink.sub) {
          if (item.internalLink.sub.name === "全部零配件") {
            this.$store.commit("search/setSearchData", {
              type: -1
            });
            this.$router.push({ path: "/new-products/product-list" });
          }
          if (item.internalLink.sub.name === "单个零配件" && item.internalLink.sub.goodsId) {
            let res = await getGoodsList({ goodsId: item.internalLink.sub.goodsId });
            if (res.totalSize === 1) {
              this.$router.push({
                path: "/new-products/product-details",
                query: {
                  data: encodeURIComponent(JSON.stringify(res.rows[0]))
                }
              });
            }
            if (res.totalSize > 1) {
              this.$store.commit("search/setSearchData", {
                goodsId: item.internalLink.sub.goodsId,
                type: -1
              });
              this.$router.push({ path: "/new-products/product-list" });
            }
            // console.log("res", res);
            // this.$router.push({
            //   path: "/new-products/product-details",
            //   query: {
            //     id: item.internalLink.sub.goodsId
            //   }
            // });
          }
        }
      }
    },
    loginOut() {
      this.$confirm("确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          logout()
            .then(() => {
              // 获取商城资料
              this.$store.dispatch("companyInfo/getCompanyInfo");
              this.$router.push({
                path: "/login"
              });
            })
            .catch(res => {
              this.$message.error(res.message || "退出失败");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    changeAccountManage() {
      this.$refs.accountManage.open();
    }
  },
  async created() {
    if (this.userInfo.userId) {
      let res = await getOrdersCounts();
      if (res) {
        this.countObj = res;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-container {
  margin-bottom: 8px;
  width: 100%;
  height: 436px;
  display: grid;
  grid-template-columns: 1fr 280px;
  gap: 4px;
  border-radius: 2px;
  overflow: hidden;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.no-banner {
  margin-bottom: 8px;
  width: 100%;
  height: 500px;
  border-radius: 2px;
  overflow: hidden;
}
.banner-section {
  position: relative;
  border-radius: 2px;
  overflow: hidden;
}

.banner-carousel {
  border-radius: 2px;
  overflow: hidden;

  :deep(.el-carousel__container) {
    border-radius: 2px;
  }

  :deep(.el-carousel__indicators) {
    bottom: 20px;

    .el-carousel__indicator {
      padding: 8px 4px;

      .el-carousel__button {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.6);
        transition: all 0.3s ease;
      }

      &.is-active .el-carousel__button {
        width: 24px;
        border-radius: 4px;
        background: #fff;
      }
    }
  }
}

.carousel-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel-image {
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1) 0%,
    transparent 30%,
    transparent 70%,
    rgba(0, 0, 0, 0.1) 100%
  );
}

.user-card-section {
  // padding: 12px;
  background: #fff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 56%, var(--color-light80) 100%);
}

.user-card {
  // background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 2px;
  padding: 14px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  height: 100%;

  // &::before {
  //   content: "";
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   height: 3px;
  //   background: linear-gradient(135deg, #3498db 0%, #2c3e50 100%);
  // }
}
.noLogo {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-logo-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
}

.no-logo-avatar {
  margin-bottom: 16px;

  .avatar-img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 3px solid #e3f2fd;
    box-shadow: 0 4px 12px rgba(52, 152, 219, 0.2);
  }
}

.no-logo-text {
  margin-bottom: 20px;

  .welcome-line1 {
    font-size: 20px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .welcome-line2 {
    font-size: 16px;
    color: #34495e;
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .welcome-tip {
    font-size: 12px;
    color: #7f8c8d;
    line-height: 1.2;
  }
}

.no-logo-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  width: 100%;

  .action-btn {
    flex: 1;
    max-width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 16px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;

    &.register-btn {
      background: #f8f9fa;
      color: #3498db;
      border: 1px solid #e9ecef;

      &:hover {
        background: #e9ecef;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      }
    }

    &.login-btn {
      background: var(--color-primary);
      color: white;

      &:hover {
        background: var(--color-primary-dark10);
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      }
    }

    i {
      font-size: 12px;
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .no-logo-avatar .avatar-img {
    width: 60px;
    height: 60px;
  }

  .no-logo-text {
    .welcome-line1 {
      font-size: 18px;
    }

    .welcome-line2 {
      font-size: 14px;
    }

    .welcome-tip {
      font-size: 11px;
    }
  }

  .no-logo-actions .action-btn {
    padding: 8px 12px;
    font-size: 13px;
  }
}
.user-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.user-avatar {
  position: relative;
  margin-right: 10px;

  .avatar-img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border: 2px solid #e3f2fd;
    box-shadow: 0 2px 6px rgba(52, 152, 219, 0.2);
  }
}

.user-details {
  flex: 1;

  .user-name {
    font-size: 15px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 2px;
    line-height: 1.2;
  }

  .user-account {
    font-size: 11px;
    color: #333;
    margin-bottom: 1px;
    line-height: 1.2;
  }

  .user-company {
    font-size: 10px;
    color: #333;
    line-height: 1.2;
  }
}

.user-actions {
  display: flex;
  gap: 6px;
  margin-bottom: 14px;

  .action-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 5px 8px;
    border: none;
    border-radius: 5px;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;

    &.switch-btn {
      background: var(--color-light80);
      color: var(--color-primary);

      &:hover {
        background: var(--color-light60);
        color: var(--color-primary-dark10);
        transform: translateY(-1px);
      }
    }

    &.logout-btn {
      background: #ffebee;
      color: #d32f2f;

      &:hover {
        background: #ffcdd2;
        transform: translateY(-1px);
      }
    }

    i {
      font-size: 10px;
    }
  }
}

.stats-section {
  margin-bottom: 14px;

  .stats-title {
    font-size: 12px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ecf0f1;
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.stat-item {
  text-align: center;
  padding: 8px 4px;
  background: #f8fafc;
  border-radius: 6px;
  transition: all 0.3s ease;

  &:hover {
    background: color-mix(in srgb, var(--color-light80) 30%, transparent);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .stat-number {
    font-size: 16px;
    font-weight: 700;
    color: var(--color-primary);
    margin-bottom: 3px;
  }

  .stat-label {
    font-size: 14px;
    color: #333;
  }
}

.benefits-section {
  .benefits-title {
    font-size: 12px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ecf0f1;
  }
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.benefit-item {
  display: flex;
  align-items: center;
  padding: 8px;
  background: #f8fafc;
  border-radius: 6px;
  transition: all 0.3s ease;

  &:hover {
    background: color-mix(in srgb, var(--color-light80) 30%, transparent);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .benefit-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    font-size: 11px;

    &.coupon-icon {
      background: linear-gradient(135deg, #ff6b6b, #ee5a24);
      color: white;
    }

    &.points-icon {
      background: linear-gradient(135deg, #f39c12, #e67e22);
      color: white;
    }
  }

  .benefit-content {
    .benefit-number {
      font-size: 13px;
      font-weight: 700;
      color: var(--color-primary);
      margin-bottom: 1px;
    }

    .benefit-label {
      font-size: 14px;
      color: #333;
    }
  }
}

@media (max-width: 1024px) {
  .banner-container {
    grid-template-columns: 1fr;
    height: auto;
  }

  .banner-section {
    height: 300px;
  }

  .banner-carousel {
    height: 300px !important;
  }

  .user-card-section {
    padding: 10px;
  }

  .user-card {
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .banner-container {
    margin-bottom: 16px;
  }

  .banner-section {
    height: 250px;
  }

  .banner-carousel {
    height: 250px !important;
  }

  .user-card {
    padding: 10px;
  }

  .stats-grid,
  .benefits-grid {
    gap: 6px;
  }

  .stat-item,
  .benefit-item {
    padding: 6px 3px;
  }
}
</style>
